import React from 'react';
export const AverageVolunteersPerSession = ({ data }) => {
  return (
    <h5 className="tw-text-left">
      Average Volunteers per Session:{" "}
      <span className="text-muted">{data}</span>
    </h5>
  )
}